module.exports = __webpack_public_path__ + "static/images/containers/Journal/images/background.70e71406.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Journal/images/background.jpg
// module id = 3109
// module chunks = 11